import { render, staticRenderFns } from "./AwaitingPaymentNotice.vue?vue&type=template&id=677a0946&scoped=true"
import script from "./AwaitingPaymentNotice.vue?vue&type=script&lang=js"
export * from "./AwaitingPaymentNotice.vue?vue&type=script&lang=js"
import style0 from "./AwaitingPaymentNotice.vue?vue&type=style&index=0&id=677a0946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677a0946",
  null
  
)

export default component.exports